import { render, staticRenderFns } from "./crudHours.vue?vue&type=template&id=351ceb48"
import script from "./crudHours.vue?vue&type=script&lang=js"
export * from "./crudHours.vue?vue&type=script&lang=js"
import style0 from "./crudHours.vue?vue&type=style&index=0&id=351ceb48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports